<template>
    <div class="history_modal_content">
        <HistoryTypeContainer
            :type="modalData.type"
            :currencyDisplay="modalData.currencyDisplay"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import HistoryTypeContainer from '@modules/userProfile/history/HistoryTypeContainer';

    export default {
        name: 'HistoryModal',
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
        },
        components: {
            HistoryTypeContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/HistoryModal.vue